export const COUNTRIES = {
    mgMotorsNetherlands: 'NL',
    mgMotorsBelgiumNl: 'BE',
    mgMotorsBelgiumFr: 'BE',
    mgMotorsAustria: 'AT',
    mgMotorsDanmark: 'DK',
    mgMotorsGermany: 'DE',
    mgMotorsSpain: 'ES',
    mgMotorsFrance: ['FR', 'MQ', 'GF', 'GP', 'RE', 'YT'],
    mgMotorsIceland: 'IS',
    mgMotorsItaly: 'IT',
    mgMotorsLuxembourgFr: 'LU',
    mgMotorsNorway: ['NO', 'SJ'],
    mgMotorsPortugal: 'PT',
    mgMotorsSweden: 'SE',
    mgMotorsSwitzerlandDe: 'CH',
    mgMotorsSwitzerlandFr: 'CH',
    mgMotorsSwitzerlandIt: 'CH',
    mgMotorsHungary: 'HU',
    mgMotorsLithuania: 'LT',
    mgMotorsEstonia: 'EE',
    mgMotorsLatvia: 'LV',
    mgMotorsPoland: 'PL',
    mgMotorsCroatia: 'HR',
    mgMotorsSlovenia: 'SI',
    mgMotorsMacedonia: 'MK',
    mgMotorsBulgaria: 'BG',
    mgMotorsAlbania: 'AL',
    mgMotorsSerbia: 'RS',
    mgMotorsBosnia: 'BA',
    mgMotorsFinland: 'FI',
    mgMotorsIreland: 'IE',
    mgMotorsCzech: 'CZ',
    mgMotorsSlovakia: 'SK',
    mgMotorsMalta: 'MT',
    mgMotorsCyprus: 'CY',
};
